var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPixIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 6.25H6.25V0.25H0.25V6.25ZM1.75 1.75H4.75V4.75H1.75V1.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 13.75H6.25V7.75H0.25V13.75ZM1.75 9.25H4.75V12.25H1.75V9.25Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 0.25V6.25H13.75V0.25H7.75ZM12.25 4.75H9.25V1.75H12.25V4.75Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 12.25H12.25V13.75H13.75V12.25Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 7.75H7.75V9.25H9.25V7.75Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 9.25H9.25V10.75H10.75V9.25Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 10.75H7.75V12.25H9.25V10.75Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 12.25H9.25V13.75H10.75V12.25Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 10.75H10.75V12.25H12.25V10.75Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 7.75H10.75V9.25H12.25V7.75Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 9.25H12.25V10.75H13.75V9.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPixIcon);
export default __webpack_public_path__ + "static/media/pix-icon.7ec31eb3.svg";
export { ForwardRef as ReactComponent };